import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Sammle alle Objekte", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Thema der Ausstellung:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Unter die Haut – wie die Medizin dem Körper Geheimnisse entlockt")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("b", null, "Gefundene Gegenstände:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = { class: "scanner" }
const _hoisted_7 = { class: "content" }

import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import {computed, inject, onMounted, ref, defineAsyncComponent} from "vue";
import Scanner from "@/components/functional/Scanner.vue";
import CollectedObjects from "@/components/functional/CollectedObjects.vue";
import { CollectionObject } from "@/types";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const ObjectSuccess = defineAsyncComponent(() => import('@/components/screens/ObjectSuccess.vue'))
const ObjectDuplicate = defineAsyncComponent(() => import('@/components/screens/ObjectDuplicate.vue'))
const ObjectFail = defineAsyncComponent(() => import('@/components/screens/ObjectFail.vue'))

const router = useRouter()
const store = useStore()
const gamehandler: any = inject('gamehandler')
const states: object = {
  new: {
    component: ObjectSuccess
  },
  duplicate: {
    component: ObjectDuplicate
  },
  wrong: {
    component: ObjectFail
  }
}

let requiredObjectsCount = computed<number>(() => {
  return store.getters['getRequiredObjectCount']
})
let collectionCount = ref<number>(0)
let collectedObjectIds = ref<Array<string>>([])
let lastDetectedObject = ref<CollectionObject|object>({})
let gameState = ref<boolean|string>(false)

let detected = (id: string): void => {
  setCollectedObjectIds()
  const collectedObject: CollectionObject = store.getters['getObjectById'](id)
  if(isCollectionObject(collectedObject)){
    lastDetectedObject.value = collectedObject
    if(isRequiredObject(collectedObject)){
      if(isNotInCollectionYet(collectedObject.id)){
        gameState.value = 'new'
        gamehandler.addToCollection(id)
        countCollection()
      }else{
        gameState.value = 'duplicate'
      }
    }else{
      gameState.value = 'wrong'
    }
  }else{
    console.log('could not find anything...')
  }
}
let notDetected = (): void => {
  console.log('nothing detected!')
}

let isRequiredObject = (object: CollectionObject): boolean => {
  return object.required;
}
let isCollectionObject = (object: CollectionObject): boolean => {
  return !(object && Object.keys(object).length === 0 && Object.getPrototypeOf(object) === Object.prototype)
}
let isNotInCollectionYet = (objectId: string): boolean => {
  return !collectedObjectIds.value.includes(objectId)
}

let countCollection = (): void => {
  collectionCount.value = gamehandler.countCollection()
}
let setCollectedObjectIds = (): void => {
  collectedObjectIds.value = gamehandler.getCollectionArray()
}

let closeStateInfo = (): void => {
  gameState.value = false
  lastDetectedObject.value = {}
  if(requiredObjectsCount.value === collectionCount.value){
    next()
  }
}
let next = () => {
  router.push('/end')
}

onMounted(() => {
  countCollection()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("p", null, [
        _hoisted_4,
        _hoisted_5,
        _createTextVNode(_toDisplayString(_unref(collectionCount)) + " / " + _toDisplayString(_unref(requiredObjectsCount)), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createVNode(Scanner, {
        onIdDetected: _unref(detected),
        onNoIdDetected: _unref(notDetected)
      }, null, 8, ["onIdDetected", "onNoIdDetected"])
    ]),
    _createElementVNode("section", _hoisted_7, [
      (_unref(collectionCount) !== 0)
        ? (_openBlock(), _createBlock(CollectedObjects, { key: _unref(collectionCount) }))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, "Du hast bis jetzt " + _toDisplayString(_unref(collectionCount)) + " von " + _toDisplayString(_unref(requiredObjectsCount)) + " Objekten gefunden.", 1)
    ]),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_unref(gameState) && _unref(isCollectionObject)(_unref(lastDetectedObject)))
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(states[_unref(gameState)].component), {
              key: 0,
              object: _unref(lastDetectedObject),
              onClose: _unref(closeStateInfo)
            }, null, 8, ["object", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})